import { Box, Button, Dialog, Grid, Skeleton, Typography } from '@mui/material'
import { useState } from 'react'
import { UpTransition } from '@components/animations'
import GeneratorElutionForm from '@components/forms/GeneratorElutionForm'
import PreparationLotForm from '@components/forms/PreparationLotForm'
import { WorkbenchCard } from '@components/workbench/WorkbenchCard'
import GeneratorElutionsTable from '@components/tables/GeneratorElutionsTable'
import PreparationLotsTable from '@components/tables/PreparationLotsTable'
import { useCurrentWorkbench } from '@hooks/useCurrentWorkbench'
import DoseCalibratorStatus from '@components/DoseCalibratorStatus'
import Timer from '@components/Timer'

export default function RadiopharmacyOperations() {
  const [elutionFormOpen, setElutionFormOpen] = useState(false)
  const [preparationFormOpen, setPreparationFormOpen] = useState(false)
  const [preparationHasPreview, setPreparationHasPreview] = useState(false)
  const [hoveredElutionId, setHoveredElutionId] = useState<string | null>(null)
  const { currentWorkbench, isLoading: isLoadingCurrentWorkbench } = useCurrentWorkbench()

  const onClosePreparationForm = () => {
    setPreparationFormOpen(false)
    setPreparationHasPreview(false)
  }

  const currentWorkbenchDisplay = isLoadingCurrentWorkbench
    ? <Skeleton variant="rounded" width={258} height={56} />
    : (
      <Box>
        {currentWorkbench && <Typography variant="body2" color="text.secondary" className="!mb-1">
          Poste de travail actif
        </Typography>}
        <WorkbenchCard workbench={currentWorkbench} withActions />
      </Box>
    )

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: { xs: 'auto', md: '100%' }, width: '100%', gap: 2 }}>
      <Box className="w-full flex flex-wrap justify-between items-start gap-3" sx={{ flexShrink: 0 }}>
        {currentWorkbenchDisplay}
        <Box display="flex" flexDirection="row" gap={2} alignItems="center">
          <DoseCalibratorStatus />
          <Timer />
        </Box>
      </Box>

      <Grid container spacing={3} sx={{ flex: { xs: 'unset', md: 1 }, minHeight: 0, alignItems: 'stretch', mt: 0 }}>
        <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', minHeight: { xs: 320, md: 0 } }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} sx={{ flexShrink: 0 }}>
            <Typography variant="subtitle1" fontWeight="medium">Élutions</Typography>
            {currentWorkbench && (
              <Button variant="contained" color="primary" size="small" onClick={() => setElutionFormOpen(true)}>
                Nouvelle élution
              </Button>
            )}
          </Box>
          <GeneratorElutionsTable containerClassName="!p-0" onElutionHover={setHoveredElutionId} />
        </Grid>

        <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', minHeight: { xs: 320, md: 0 } }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} sx={{ flexShrink: 0 }}>
            <Typography variant="subtitle1" fontWeight="medium">Préparations</Typography>
            {currentWorkbench && (
              <Button variant="contained" color="primary" size="small" onClick={() => setPreparationFormOpen(true)}>
                Nouvelle préparation
              </Button>
            )}
          </Box>
          <PreparationLotsTable containerClassName="!p-0" hoveredElutionId={hoveredElutionId} />
        </Grid>
      </Grid>

      <Dialog
        open={elutionFormOpen}
        onClose={() => setElutionFormOpen(false)}
        fullWidth
        maxWidth="md"
        TransitionComponent={UpTransition}
      >
        <GeneratorElutionForm onClose={() => setElutionFormOpen(false)} />
      </Dialog>
      <Dialog
        open={preparationFormOpen}
        onClose={onClosePreparationForm}
        fullWidth
        maxWidth={preparationHasPreview ? 'lg' : 'sm'}
        TransitionComponent={UpTransition}
        PaperProps={{
          sx: {
            maxHeight: '85vh', 
            margin: '16px',
          }
        }}
      >
        <PreparationLotForm
          onClose={onClosePreparationForm}
          onPreviewChange={setPreparationHasPreview}
        />
      </Dialog>
    </Box>
  )
}
